import { get, put, remove } from "../../utils/httpClient";

const customFieldGroupService = () => {
  const prefixApi = "duedates/customfieldgroup";

  const getCustomFieldGroupByTaskTypeId = async (
    taskTypeId,
    showHidden = true
  ) => {
    return await get(`/${prefixApi}/tasktype`, {
      taskTypeId: taskTypeId,
      showHidden: showHidden,
    });
  };

  const getCustomFieldGroup = async (id) => {
    return await get(`/${prefixApi}/${id}`);
  };

  const createOrUpdateCustomFieldGroup = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  const updateGroupVisibility = async (json) => {
    return await put(`/${prefixApi}/visibility`, json);
  };

  const deleteCustomFieldGroup = async (id) => {
    return await remove(`/${prefixApi}/${id}`);
  };

  return {
    getCustomFieldGroupByTaskTypeId,
    getCustomFieldGroup,
    createOrUpdateCustomFieldGroup,
    updateGroupVisibility,
    deleteCustomFieldGroup,
  };
};

export default customFieldGroupService;
